import React from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  select {
    height: 36px;
    border-radius: 5px;
    ${(props) => (props.error ? "border: 1px solid red" : "")};
  }

  label {
    color: ${(props) => (props.error ? "red" : "")};
  }
`;

const Select = React.forwardRef(
  (
    { onChange, name, textProperty, valueProperty,label, list, error, icon,disabled },
    ref
  ) => (
    <>
    
        <div className="form-group mb-2">
        <InputWrapper error={error}>
          <i className={icon}></i>
          {label && <label htmlFor={name}>{label}</label>}
          <div className="input-group ">
            <select
              disabled={disabled}
              className="form-select "
              name={name}
              ref={ref}
              onChange={onChange}
            >
              {list &&
                list.map((item) => (
                  <option key={item[valueProperty]} value={item[valueProperty]}>
                    {item[textProperty]}
                  </option>
                ))}

            </select>
          </div>
          </InputWrapper>
          {/* {errors && <div className="alert alert-danger">{errors.message}</div>} */}
        </div>
     
    </>
  )
);
Select.defaultProps = {
  textProperty: "name",
  valueProperty: "_id",
};
export default Select;
